export default {
	data() {
		return {
			mounted: false
		}
	},
	mounted() {
		this.mounted = true
	},
	beforeDestroy() {
		this.mounted = false
	}
}
